import { Component, ViewChildren, QueryList, ElementRef, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';

interface Formato {
  label: string;
  archivo: File | null;
  tipoIniciativa: number | null; // Asociar el tipo de iniciativa
}

@Component({
  selector: 'app-formatos-apoyo',
  templateUrl: './formatos.component.html',
  styleUrls: ['./formatos.component.css']
})
export class FormatosApoyoComponent implements OnInit {
  formatos: Formato[] = [
    { label: 'Nuevo sistema', archivo: null, tipoIniciativa: 1 },
    { label: 'Cambio con cambio a proceso', archivo: null, tipoIniciativa: 2 },
    { label: 'Cambio sin cambio a proceso', archivo: null, tipoIniciativa: 3 }
  ];

  emailUsuario: string; // Email del usuario logueado
  loading: boolean = false;

  urlAPI2: string = environment.UrlApiV2;

  @ViewChildren('fileInputs') fileInputs!: QueryList<ElementRef>;

  constructor(private http: HttpClient, private autService: AuthService) {
    this.autService.user.subscribe((user: string) => {
      this.emailUsuario = user;
    });
  }

  ngOnInit() {
  }

  onFileSelected(event: any, index: number) {
    const file = event.target.files[0];
    this.formatos[index].archivo = file;
  }

  abrirSelectorArchivo(index: number) {
    const fileInput = this.fileInputs.toArray()[index];
    fileInput.nativeElement.click();
  }

  guardarArchivo(index: number) {
    const archivo = this.formatos[index].archivo;
    const tipoIniciativa = this.formatos[index].tipoIniciativa;

    if (archivo) {
      const formData = new FormData();
      formData.append('contenido', archivo);
      formData.append('email', this.emailUsuario);
      formData.append('tipoIniciativa', tipoIniciativa?.toString() || '');

      this.loading = true; // Empieza el indicador de carga

      this.http.post(`${this.urlAPI2}Archivo/subirFormatoAyuda`, formData).subscribe(
        res => {
          alert('Archivo guardado correctamente.');
          this.formatos[index].archivo = null; // Limpia el archivo después de guardarlo
        },
        err => {
          console.error(err);
          alert('Error al subir el archivo. Por favor, intenta nuevamente.');
        },
        () => {
          this.loading = false; // Detiene el indicador de carga después de completar
        }
      );
    } else {
      alert('No se ha seleccionado ningún archivo.');
    }
  }

  cancelarArchivo(index: number) {
    this.formatos[index].archivo = null;
    const fileInput = this.fileInputs.toArray()[index];
    fileInput.nativeElement.value = ''; // Limpia el campo de entrada de archivo
  }
}
